import Error from 'components/Error'
import Loading from 'components/Loading'
import React, { FC, ReactNode } from 'react'

type ContentWrapperProps = {
  onButtonClicked: () => void
  minHeightError: number
  errorCode?: number
  isLoading: boolean
  loadingFullscreen?: boolean
  showChildWhenLoading?: boolean
  children: ReactNode
}

const ContentWrapper: FC<ContentWrapperProps> = ({
  onButtonClicked,
  minHeightError,
  errorCode,
  children,
  isLoading,
  loadingFullscreen = false,
  showChildWhenLoading = false,
}) => {
  if (errorCode || isLoading) {
    return (
      <>
        {!errorCode && loadingFullscreen && isLoading ? (
          <Loading fullscreen />
        ) : (
          <Error
            isLoading={isLoading && !errorCode}
            minHeight={minHeightError}
            onButtonClicked={onButtonClicked}
            errorCode={errorCode}
          />
        )}
        {!errorCode && showChildWhenLoading && isLoading && children}
      </>
    )
  }

  return children
}

export default ContentWrapper
